import { useCallback } from 'react';

import useUpdateTicketCache from './useUpdateTicketCache';

const useUpdateTicketResponsesCache = () => {
  const updateTicketCache = useUpdateTicketCache();

  const updateTicketResponsesCache = useCallback(
    ({ ticketId, responses }) => {
      updateTicketCache({
        ticketId,
        callback: oldTicket => {
          return {
            ...oldTicket,
            subscriber: {
              ...oldTicket.subscriber,
              latest_message: responses[responses.length - 1]
            }
          };
        }
      });
    },
    [updateTicketCache]
  );

  return updateTicketResponsesCache;
};

export default useUpdateTicketResponsesCache;
